<header>
  <div class="container">
    <br />
    <div class="row">
      <div class="col-md-10">
      </div>
      <div class="col-md-2">
        <span style="padding-top: 3%; font-size: 1.6em; font-weight: 700; ">
          <div class="container" style="border: 1px solid #257dff; border-radius: 25px; ">
            &nbsp;&nbsp;Español
          </div>
        </span>
      </div>
    </div>
  </div>
  <div class="container">
    <br />
    <div class="row">
      <div class="col-md-12">
        <span style="padding-top: 3%; font-size: 1.6em; font-weight: 700">
          GoogleAssistantPrivacyLitigation.com
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(877) 411-4704
        </span>
      </div>
    </div>
  </div>
  <br />
  <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light  border-bottom " style="background-color: #257dff ">
    <div class="container">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse justify-content-center" [ngClass]="{ show: isExpanded }">
        <ul class="navbar-nav flex-grow">
          <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link  hover_lightBlue" [routerLink]="['/home']" style="color: white; font-weight: bold ">Home</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/faq']" style="color: white; font-weight: bold">FAQs</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/notice']" style="color: white; font-weight: bold ">Notice</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/login']" style="color:white; font-weight: bold ">File Your Claim</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/claim-form']" style="color:white; font-weight: bold ">Claim Form</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/court-documents']" style="color:white; font-weight: bold ">Court Documents</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/exclusion-request']" style="color:white; font-weight: bold ">File an Exclusion</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/contact']" style="color:white; font-weight: bold ">Contact Us</a>
          </li>
        </ul>
      </div>
    </div>

  </nav>


</header>
<div class="container" style="border:1px solid #bebaba">

  <br />
  <div class="text-center" style="font-weight:bold">

    This official website is maintained by the Claims Administrator
    <br />
    <br />
    <br />
  </div>
  <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align: center; font-weight: bold">
    <h3>Claim Form</h3>
  </div>
  <div class="row indentContent">
    <div class="col-md-12">
      <p style="font-weight:bold">Please use the links below to view the Claim Form.</p>

      <ul>
        <li>
          <a href="../../../assets/documents/In re Google Assistant Claim Form_Final.pdf"
             target="_blank">
            Claim Form – English
          </a>
        </li>
        <li>
          <a href="../../../assets/documents/In re Google Assistant Claim Form_Final-ES.pdf"
             target="_blank">
            Claim Form – Spanish
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div style="width:80%; margin:0 auto; text-align: center; display:block; margin-top: 2%">
    <p>
      Note: These documents are in PDF format. To view the<br />
      documents, you will need <a href="https://get.adobe.com/reader/" target="_blank"
                                  style="color:#0071ce; font-weight:bold">Adobe Acrobat Reader</a>
      on your computer or other internet-enabled device.
    </p>
  </div>
  <div class="row text-center" id="inverse_row">
    <div class="col-md-12">
      <a href="https://get.adobe.com/reader/" target="_blank"><img src="../assets/adobe-pdf-icon.jpg" alt="Adobe Acrobat Reader" width="3%"></a>
    </div>
  </div>
  <br />
</div>
